export const phoneRegex = {
  regex: /^\+?[0-9]*$/,
  message: 'A helyes mobilszám formátuma: +36201231212 vagy 06201231212',
};
